import React from 'react'
import { usePostRequest } from '../hooks/request'
import { CURRENCY_LIST } from '../urls'
import { useMessage } from '../hooks/message'
import CurrencyForm from './CurrencyForm'

export default function CurrencyCreate({ onSuccess, onCancel }) {
    const brandCreate = usePostRequest({ url: CURRENCY_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const { success } = await brandCreate.request({ data })

        if (success) {
            showMessage('Успешно сохранен', 'is-success')
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered"><b>Добавить курс доллара США</b></h1>

            <CurrencyForm
                loading={brandCreate.loading}
                onSubmit={onSubmit}
                onCancel={onCancel} />
        </div>
    )
}
